import { takeEvery } from 'redux-saga/effects'

import { COMMIT, DID } from 'app/constants/identityActions'
import { showSuccess } from 'store/entities/toastr/utils'
import * as STAGES from 'app/constants/stages'
import { ACTIVITY_COMMITED, ACTIVITY_FINISHED } from 'app/constants/toastrMessages'
import { activityActions } from '../actions'

export default function* getIdentityProgressSuccess() {
  yield takeEvery(
    [
      activityActions.commit.success.toString(),
      activityActions.did.success.toString(),
      activityActions.didnot.success.toString(),
      activityActions.complete.success.toString(),
    ],
    getIdentityProgressSuccessHandler
  )
}

export function getIdentityProgressSuccessHandler({ payload: { data } }) {
  if (!data) {
    return
  }
  if (data.stage === STAGES.PROCEED || data.stage === STAGES.DONE) {
    const { activity, lastActivity } = data
    const actionType = activity ? activity.actionType : lastActivity.actionType

    switch (actionType) {
      case COMMIT:
        showSuccess({ content: ACTIVITY_COMMITED })
        break
      case DID:
        showSuccess({ content: ACTIVITY_FINISHED })
        break
      default:
        break
    }
  }
}
